export const easeOutExpo = [0.16, 1, 0.3, 1];

export const fadeUp = {
  hidden: { opacity: 0, y: 40 },
  show: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.8, ease: easeOutExpo },
  },
};

export const stagger = {
  hidden: {},
  show: {
    transition: { staggerChildren: 0.12, delayChildren: 0.1 },
  },
};

export const lineReveal = {
  hidden: { y: "110%" },
  show: (i = 0) => ({
    y: "0%",
    transition: { duration: 0.9, ease: easeOutExpo, delay: 0.15 + i * 0.12 },
  }),
};

// Heading lines drop down from above their mask (staggered).
export const lineDrop = {
  hidden: { y: "-110%" },
  show: (i = 0) => ({
    y: "0%",
    transition: { duration: 0.9, ease: easeOutExpo, delay: 0.15 + i * 0.12 },
  }),
};

// Sharp clip/mask reveal — sleek editorial entrance for panels & images.
export const clipReveal = {
  hidden: { clipPath: "inset(0 100% 0 0)", opacity: 0.4 },
  show: {
    clipPath: "inset(0 0% 0 0)",
    opacity: 1,
    transition: { duration: 1, ease: easeOutExpo },
  },
};

export const scaleIn = {
  hidden: { opacity: 0, scale: 0.96 },
  show: { opacity: 1, scale: 1, transition: { duration: 0.7, ease: easeOutExpo } },
};
